// extracted by mini-css-extract-plugin
export var container = "styles-module__container___Mm6xJ";
export var contentContainer = "styles-module__contentContainer___L7Zif";
export var fadeIn = "styles-module__fadeIn___JNqoF";
export var heading = "styles-module__heading___fDs5S";